import React from "react";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Image from "@insightfulscience/atomic-react/Image";
import ContactForm from "./ContactForm";

const ContactFormSection = () => {
	const [t] = useLocale("contact-form");

	return (
		<LandingSimpleSection utility={{ bgColor: "4" }}>
			<Container>
				<Row px py utility={{ justify: "center" }} spacing={{ md: { p: 20 }, sm: { py: 20 } }}>
					<Col lg={5} md={11} sm={12}>
						<Row px py utility={{ justify: "center" }} spacing={{ lg: { mt: 20 } }}>
							<Col>
								<Heading Tag="h2" sx={{ fontSize: "xl" }} spacing={{ sm: { p: 5 } }}>
									{t("FORM_TITLE")}
								</Heading>
								<Paragraph spacing={{ sm: { p: 5 } }}>{t("FORM_DESCRIPTION")}</Paragraph>
							</Col>
						</Row>
						<Row
							px
							py
							spacing={{ ml: "m40", mt: 15 }}
							utility={{
								sm: { display: "none" },
								md: { display: "none" },
								lg: { display: "flex" },
							}}
						>
							<Col shrink>
								<Image src={t("FORM_IMAGE_1")} />
							</Col>
							<Col shrink>
								<Image src={t("FORM_IMAGE_2")} />
							</Col>
						</Row>
					</Col>
					<Col lg={7} md={11} sm={12} utility={{ bgColor: "white", radius: 8 }} spacing={{ p: 10 }}>
						<ContactForm />
					</Col>
				</Row>
			</Container>
		</LandingSimpleSection>
	);
};

export default ContactFormSection;
